import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import MessageSettingsService from 'cio/services/message-settings';
import ConfirmChangesService from 'cio/services/confirm-changes';
import CampaignsCampaignSetupTriggerIndexController from './controller';
import CampaignModel from 'cio/models/campaign';
import Transition from '@ember/routing/-private/transition';
import FeaturesService from 'ember-feature-flags/services/features';

export default class IndexRoute extends Route {
  @service messageSettings!: MessageSettingsService;
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;
  @service features!: FeaturesService;

  model() {
    return this.modelFor('campaigns.campaign');
  }

  afterModel() {
    let promises = [this.store.findAll('short-segment'), this.messageSettings.loadMessagingLimit.perform()];
    if (this.features.isEnabled('campaign_trigger_ui_new')) {
      promises.push(this.store.findAll('recent-trigger'));
    }
    return Promise.all(promises);
  }

  setupController(
    controller: CampaignsCampaignSetupTriggerIndexController,
    campaign: CampaignModel,
    transition: Transition,
  ) {
    super.setupController(controller, campaign, transition);
    controller.prepareForEdit(campaign);
    this.confirmChanges.register(controller, this);
  }

  redirect(campaign: CampaignModel) {
    if (campaign.isApiTriggered) {
      this.router.transitionTo('campaigns.campaign.setup.recipients');
    }
  }
}
